const NAME = "RECEIPTS_PAGE";

export default NAME;
